import { config, authHeader } from '../helpers'
import { handleHttpResponse } from '../helpers';
import moment from 'moment';
// import { POD_SETUPS } from '../helpers';

export const PODService = {
    addPOD,
    modifyPod,
    modifyPodName,
    getActivePods,
    deleteHeadpoint,
    deletePOD,
    addPodRequest,
    loadPodRequests,
    getDatesOfFirstAndLastData,
    // isPodSetupValid,
    uploadConsentFile
}

function uploadConsentFile({ consentFile }) {
        const query = `mutation{
            uploadConsentFile(
                consentFile : ${ consentFile }
            )
                {
                    s3Path
                }
            }`
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/graphql', ...authHeader() },
            body: query
            }
            return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
                return handleHttpResponse(response)
                .then(data => data.uploadConsentFile)
            })
}

function addPOD(clientID, EAN, fluid, unit, podCustomName, variables, timeframes, directions, meters, validFrom, addressID,
  { country, postalCode, localityName, streetName, streetNumber, boxNumber, customName }, energyID) {

    const query = `mutation{
        addPod(
            clientID: ${JSON.stringify(clientID)},
            EAN: ${JSON.stringify(EAN)},
            fluid: ${JSON.stringify(fluid)},
            unit: ${JSON.stringify(unit)},
            customName: ${podCustomName ? JSON.stringify(podCustomName) : null},
            variables: ${JSON.stringify(variables)},
            timeframes: ${JSON.stringify(timeframes)},
            directions: ${JSON.stringify(directions)},
            meters: ${JSON.stringify(meters)},
            validFrom: ${JSON.stringify(validFrom)},
            locationID: ${addressID ? JSON.stringify(addressID) : null},
            country: ${country ? JSON.stringify(country) : null},
            postalCode: ${postalCode ? JSON.stringify(postalCode) : null},
            localityName: ${localityName ? JSON.stringify(localityName) : null},
            streetName: ${streetName ? JSON.stringify(streetName) : null},
            streetNumber: ${streetNumber ? JSON.stringify(streetNumber) : null},
            boxNumber: ${boxNumber ? JSON.stringify(boxNumber) : null},
            addressCustomName: ${customName ? JSON.stringify(customName) : null},
            energyID: ${JSON.stringify(energyID)},
        )
            {
                id
            }
        }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
      }
      return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
            .then(data => {
                return data.addPod
            },
            error => Promise.reject(error))
        })
}

function modifyPod(clientID, podID, EAN, fluid, unit, podCustomName, variableIDs, variableNames, timeframes, directions, meters, deletedVariables, addressID, { country, postalCode, localityName, streetName, streetNumber, boxNumber, customName }, registersSources) {

    const query = `mutation{
      modifyPod(
          clientID: ${JSON.stringify(clientID)},
          podID: ${JSON.stringify(podID)},
          EAN: ${JSON.stringify(EAN)},
          fluid: ${JSON.stringify(fluid)},
          unit: ${JSON.stringify(unit)},
          customName: ${podCustomName ? JSON.stringify(podCustomName) : null},
          variableIDs: ${JSON.stringify(variableIDs)},
          variables: ${JSON.stringify(variableNames)},
          timeframes: ${JSON.stringify(timeframes)},
          directions: ${JSON.stringify(directions)},
          meters: ${JSON.stringify(meters)},
          deletedVariables: ${JSON.stringify(deletedVariables)},
          locationID: ${addressID ? JSON.stringify(addressID) : null},
          country: ${country ? JSON.stringify(country) : null},
          postalCode: ${postalCode ? JSON.stringify(postalCode) : null},
          localityName: ${localityName ? JSON.stringify(localityName) : null},
          streetName: ${streetName ? JSON.stringify(streetName) : null},
          streetNumber: ${streetNumber ? JSON.stringify(streetNumber) : null},
          boxNumber: ${boxNumber ? JSON.stringify(boxNumber) : null},
          addressCustomName: ${customName ? JSON.stringify(customName) : null},
          variableSources:${JSON.stringify(registersSources)}
      )
          {
              id
          }
      }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
      }
      return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
            return handleHttpResponse(response)
            .then(data => data.modifyPod);
        })
}

function modifyPodName(clientID, podID, podName) {

    const query = `mutation{
        modifyPodName(
          clientID: ${JSON.stringify(clientID)},
          podID: ${JSON.stringify(podID)},
          podName: ${podName ? JSON.stringify(podName) : null}
      )
          {
              id
          }
      }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
      }
      return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
            return handleHttpResponse(response)
            .then(data => data.modifyPodName)
        })
}

function getActivePods(userID, needLocation) {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/graphql', ...authHeader() }
    };
    const query = `activePods(clientID: ${JSON.stringify(userID)}){
      validFrom
      validTo
      podCustomName
      personalizedEnergyConversion
      isDelegatedAccess
      hasReadPermission
      hasWritePermission
      pod {
        id
        EAN
        source
        inputType
        fluid
        unit
                includeIntervalReadings
        energy {
          id
          energyName
          inputUnit
          hasCumulativeIndexes
          conversionToKWH
        }
        variable {
          id
          name
          source
          timeframe
          meter
          direction
          validFrom
          validTo
          serviceComponent
          serviceComponentElement
        }
        ${needLocation ? 
            `location {
                id
                streetName
                streetNumber
                localityName
                postalCode
                country
                source
                boxNumber
                customName
            }`
            : ``}
      }
    }`;
    return fetch(`${config.apiUrl}/graphql?query={${query}}`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.activePods);
      })
}

function deleteHeadpoint(clientID, podID) {
    const query = `mutation{
        deleteHeadpoint(
            clientID: ${JSON.stringify(clientID)},
            podID: ${JSON.stringify(podID)}
        )
            {
                ID
            }
        }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    }
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.deleteHeadpoint)
    })
}

// obsolete function
function deletePOD(clientID, podID) {

    const query = `mutation{
        deletePod(
            clientID: ${JSON.stringify(clientID)},
            podID: ${JSON.stringify(podID)}
        )
            {
                id
            }
        }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
      }
      return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
            return handleHttpResponse(response)
            .then(data => data.deletePod);
        })
}

function addPodRequest(clientID,
    {
        // user infos
        name,
        firstName,
        phoneNumber,
        // email,
        // owner infos
        // isDelegation,
        // ownerLastName,
        // ownerFirstName,
        // ownerPhoneNumber,
        // ownerEmail,
        // pod infos
        dgo,
        ean,
        meter,
        // energyName,
        // owner address info
        ownerStreetName,
        ownerStreetNumber,
        ownerBoxNumber,
        ownerPostalCode,
        ownerLocality,
        // comment
        comment,
    }) {
        const today = moment().format("YYYY-MM-DD");
        const query = `mutation{
            addPodRequest(
                clientID: ${JSON.stringify(clientID)},
                firstName: ${JSON.stringify(firstName)},
                lastName: ${JSON.stringify(name)},
                phone: ${JSON.stringify(phoneNumber)},
                dgo: ${JSON.stringify(dgo)}
                EAN : ${JSON.stringify(ean.trim())},
                meter : ${JSON.stringify(meter.trim())},
                streetName : ${JSON.stringify(ownerStreetName)},
                streetNumber : ${JSON.stringify(ownerStreetNumber)},
                boxNumber : ${JSON.stringify(ownerBoxNumber)},
                localityName : ${JSON.stringify(ownerLocality)},
                postalCode : ${JSON.stringify(ownerPostalCode)},
                comment : ${JSON.stringify(comment)},
                requestDate : ${JSON.stringify(today)}
            )
                {
                    status
                }
            }`;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/graphql', ...authHeader() },
            body: query
            }
            return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
                return handleHttpResponse(response)
                .then(data => data.addPodRequest);
            })
}

function loadPodRequests(clientID) {
    const query = `{
        podRequests(clientID: ${JSON.stringify(clientID)}) {
            id
            clientID
            firstName
            lastName
            phone
            mail
            delegation
            delegatedFirstName
            delegatedLastName
            delegatedPhone
            delegatedMail
            EAN
            meter
            fluid
            streetName
            streetNumber
            boxNumber
            localityName
            postalCode
            comment
            evidence
            requestDate
            status
        }
      }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    };
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.podRequests);
      })
}

function getDatesOfFirstAndLastData(podIDs) {
    const query =
    `{
        dateOfFirstAndLastData(podIDs: ${JSON.stringify(podIDs)}) {
            firstDataDate
            lastDataDate
        }
    }`
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader( )},
        body: query
    }
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.dateOfFirstAndLastData)
    })
}

// function isPodSetupValid(timeframes, directions, energyName) {
//     if(energyName != 'elec') {
//         if(timeframes.length > 1 || directions[0] == 'injection' || timeframes[0] != 'TH') {
//             return false
//         }
//         return true
//     }
//     let withdrawalTimeframes = []
//     let injectionTimeframes = []
//     for(let directionIndex in directions) {
//         if(directions[directionIndex] == 'injection') {
//             injectionTimeframes.push(timeframes[directionIndex])
//         }
//         else {
//             withdrawalTimeframes.push(timeframes[directionIndex])
//         }
//     }

//     // vérifier séparément qu'il n'y a pas de timeframe en double sur les prélèvements
//     if(withdrawalTimeframes.some((tf, tfIndex) => { return withdrawalTimeframes.indexOf(tf) != tfIndex })) {
//         return false
//     }
//     // vérifier séparément qu'il n'y a pas de timeframe en double sur les injections
//     if(injectionTimeframes.some((tf, tfIndex) => { return injectionTimeframes.indexOf(tf) != tfIndex })) {
//         return false
//     }

//     // vérifier que les registres en prélèvement correspondent à un setup autorisé
//     // pour ca : parcourir les pod setups connus du portail et essayer d'en trouver un
//     // qui contient les memes éléments que ceux passés en argument
//     const isCorrectWithdrawalSetup = POD_SETUPS.ELEC.WITHDRAWAL.some(allowedWithdrawalSetup => {
//         // if same number of withdrawal timeframes => check if they are the same
//         if(allowedWithdrawalSetup.length == withdrawalTimeframes.length) {
//             return allowedWithdrawalSetup.every(timeframeToFind => withdrawalTimeframes.indexOf(timeframeToFind) != -1)
//         }
//         return false
//     })
//     if(!isCorrectWithdrawalSetup) {
//         return false
//     }

//     // vérifier que les registres en injection correspondent à un setup autorisé
//     // pour ca : parcourir les pod setups connus du portail et essayer d'en trouver un
//     // qui contient les memes éléments que ceux passés en argument
//     const isCorrectInjectionSetup = POD_SETUPS.ELEC.INJECTION.some(allowedInjectionSetup => {
//         // if same number of withdrawal timeframes => check if they are the same
//         if(allowedInjectionSetup.length == injectionTimeframes.length) {
//             return allowedInjectionSetup.every(timeframeToFind => injectionTimeframes.indexOf(timeframeToFind) != -1)
//         }
//         return false
//     })
//     if(!isCorrectInjectionSetup) {
//         return false
//     }
//     return true
// }